<template>
    <div :class="containerClass" class="py-2">
            <div v-for="(answer, index) in validAnswers" :key="index">
           
                <div class="subtitle is-size-6 answer columns is-mobile is-vcentered mb-5" :class="answer.correct?'correct':''">
                        <div class="column is-11 secondary-font-bold">
                            {{ answer.value }}
                        </div>
                    
                        <div class="column is-1">
                            <span
                                class="icon is-large is-pull-right"
                                v-if="answer.correct"
                            >
                                <i
                                    class="
                                        mdi mdi-24px mdi-checkbox-marked-outline
                                    "
                                ></i>
                                
                            </span>
                        </div>
                   
                </div>
            </div>
    </div>
</template>

<script>
import InputAnswer from '@/components/InputAnswer';
import _ from 'underscore';
import {
    ANSWER_TYPES,
    DEFAULT_ANSWER_TYPE,
    EMPTY_ANSWER_TYPE,
} from '@/lib/constants';
export default {
    components: {
        InputAnswer,
    },
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
        answerType: {
            type: String,
            default: EMPTY_ANSWER_TYPE,
        },
    },
    data() {
        return {
            containerClass: undefined,
            createdAnswers: [],
            answerTypes: ANSWER_TYPES,
            answerTypeLocal: this.answerType,
            previousAnswerTypeLocal: EMPTY_ANSWER_TYPE,
        };
    },
    computed: {
        validAnswers() {
            return _.filter(this.answers, (answer) => {
                return answer && answer.value;
            });
        },
    },
    
    mounted() {
    },
    methods: {
        
    },
};
</script>

<style scoped>
.answer{
    color: #000000;
    border: 1px solid var(--eduloc-grey);
    border-radius: 0;
    min-height: 4.5rem;
    background-color: var(--eduloc-grey-background);
    padding-left: 1rem;
    padding-right: 1rem;

}
.answer.correct{
    background-color: var(--eduloc-green);
    color: white;
}
</style>